<div [formGroup]="form">
  <div [ngSwitch]="formItem.controlType" class="input-item-container">
    <input
      class="input-item"
      *ngSwitchCase="'textbox'"
      [formControlName]="formItem.key"
      [id]="formItem.key"
      [type]="formItem.type"
      [placeholder]="formItem.placeholder"
    />

    <input
      class="input-item"
      *ngSwitchCase="'date'"
      [formControlName]="formItem.key"
      [id]="formItem.key"
      type="text"
      [placeholder]="formItem.placeholder"
      appDynamicDateInput
    />

    <input
      class="input-item"
      *ngSwitchCase="'datetime'"
      [formControlName]="formItem.key"
      [id]="formItem.key"
      type="text"
      [placeholder]="formItem.placeholder"
      appDynamicDatetimeInput
    />

    <select
      [id]="formItem.key"
      *ngSwitchCase="'dropdown'"
      [formControlName]="formItem.key"
    >
      <option *ngFor="let opt of formItem.options" [value]="opt.key">
        {{ opt.value }}
      </option>
    </select>
  </div>
</div>
